module.exports = __webpack_public_path__ + "img/REFRESH.0571dbcf.svg";